import {
  Component,
  inject
} from '@angular/core';
import { NgxTolgeeModule } from '@tolgee/ngx';

import { ContactComponent } from '../contact/contact.component';
import { emulateClick } from '../core/a11y';
import { InnerHtmlComponent } from '../shared/components/inner-html/inner-html.component';
import { CenterService } from '../shared/services/center.service';
import { FaqService } from '../shared/services/faq.service';

@Component({
  selector: 'app-faq',
  imports: [
    NgxTolgeeModule,
    ContactComponent,
    InnerHtmlComponent
  ],
  templateUrl: './faq.component.html'
})
export class FaqComponent {
  readonly emulateClick = emulateClick;
  centerService = inject(CenterService);
  faqService = inject(FaqService);
  expanded: Set<string> = new Set();
}
